import { convertFromRadiansToDegree } from '~/core/helpers';

export const calculateCornerAngleInDegrees = (cornerAngleInRadians: number) => {
  const cornerAngleInDegrees = Math.round(
    convertFromRadiansToDegree(cornerAngleInRadians)
  );

  return cornerAngleInDegrees > 180
    ? cornerAngleInDegrees - 360 // makes all interior angles negative
    : cornerAngleInDegrees;
};
